import { render } from "./SecurityDashboard.vue?vue&type=template&id=57e9edd6&scoped=true"
import script from "./SecurityDashboard.vue?vue&type=script&lang=js"
export * from "./SecurityDashboard.vue?vue&type=script&lang=js"

import "./SecurityDashboard.vue?vue&type=style&index=0&id=57e9edd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e9edd6"]])

export default __exports__